/**
 * Shared promo campaign metadata for the 6-month subscription discount banner & pricing UI.
 */
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || '';

export let currentPromoConfig = {
  is_enabled: true,
  discount_percent: 30,
  end_date: '2026-08-31T23:59:59+05:30',
  banner_text: 'Get 30% off on 6 monthly plan 31 Aug only',
  badge_text: '-50%',
  cta_text: 'Claim 30% off',
  target_billing_cycle: '6-month',
};

// Fallback / legacy constants
export const PROMO_END_DATE = new Date(currentPromoConfig.end_date);
export const PROMO_PERCENT = 30;
export const PROMO_BILLING_CYCLE = '6-month';
export const PROMO_CODE = 'AUG30';
export const PROMO_VERSION = 'six-month-30-aug2026-v1';
export const PROMO_DISMISS_KEY = `gn_promo_dismissed_${PROMO_VERSION}`;

let fetchPromise = null;

export const fetchPromoConfig = async () => {
  if (fetchPromise) return fetchPromise;
  fetchPromise = (async () => {
    try {
      const res = await axios.get(`${BACKEND_URL}/api/v2/discounts/promo-banner`);
      if (res.data) {
        currentPromoConfig = { ...currentPromoConfig, ...res.data };
      }
    } catch (e) {
      try {
        const fallbackRes = await axios.get(`${BACKEND_URL}/api/discounts/promo-banner`);
        if (fallbackRes.data) {
          currentPromoConfig = { ...currentPromoConfig, ...fallbackRes.data };
        }
      } catch (err) {
        // use default config
      }
    }
    return currentPromoConfig;
  })();
  return fetchPromise;
};

export const isPromoActive = (config = currentPromoConfig) => {
  if (!config || !config.is_enabled) return false;
  if (!config.end_date) return true;
  return new Date() <= new Date(config.end_date);
};

export const PROMO_SIX_MONTH_TOTAL_SAVING_PCT = 50;

export const formatPromoEndDate = (endDateStr) => {
  const targetDate = endDateStr ? new Date(endDateStr) : new Date(currentPromoConfig.end_date);
  return targetDate.toLocaleDateString('en-IN', {
    day: 'numeric',
    month: 'short',
    year: 'numeric',
    timeZone: 'Asia/Kolkata',
  });
};
